<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
</script>

<template>
  <KBtn
    size="xs"
    priority="info"
    :class="$style.exportAsPdfIconBtn2"
    icon="mdi-file-delimited-outline"
    data-testid="exportAsCsvIconBtn"
    title="Export as CSV"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.exportAsCsvIconBtn {
}
</style>
